<template>
    <div class="container mobile-container">
        <div class="PagePanelWrapper">
            <slot/>
        </div>
    </div>
</template>

<script>
export default {
    name: "PagePanelWrapper"
}
</script>

<style lang="scss">
.PagePanelWrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;

  padding-top: 40px;
  padding-bottom: 24px;

  @include tablet {
    padding: 24px 0;
  }

  @include mobile {
    padding: 16px 0;
  }
}
</style>